import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const generalmotors = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "GM Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "Willkommen bei der Werkstatt-Buchung von General Motors",
      },
      layout: {
        backText: "Zurück zu gm.com",
      },
      linkToHome: "https://www.gm.com/",
    },
  },
};
